import { useState, useEffect } from 'react';
import { fetchAPI, UrlParams } from '../services/strapi';

function mapBody(body: any) {
  return {
    component: `${body.__component}`.replace('blog-components.', ''),
    body: body.body,
    _uid: ''
  };
}

function selectValidBody(body: any) {
  return body?.find((v: any) => v?.body);
}

function mapResponse(result: any) {
  return {
    id: result.id,
    title: result.attributes.title,
    author: result.attributes.author,
    description: result.attributes.description,
    date:  result.attributes.date,
    body: selectValidBody(result.attributes.body)?.body || '',
    components: result.attributes.body.map((item: any) => mapBody(item)),
    img: result.attributes.img?.data?.attributes.url,
    thumb: result.attributes.thumb?.data?.attributes.url,
    index: result.attributes.index
  };
}

export type Search = {
  buscaLivre?: string;
  author?: string;
  initialDate?: string;
  finalDate?: string;
  index?: string;
}

type apiResponse = {
  data: any[],
  meta: {
		pagination: {
			page: number,
			pageSize: number,
			pageCount: number,
			total: number
		}
	}
}

export type Response = {
  results: any[],
  pagination: {
    page: number,
    pageSize: number,
    pageCount: number,
    total: number
	}
}

function mountFilter(array: any[], field: string | undefined | null, fieldTitle: string, operator: string = "$containsi") {
  if(field) {
    let filter: any = {};
    filter[fieldTitle] = {};
    filter[fieldTitle][operator] = field;

    array.push(filter);
  }
}

function mountCaseSensitiveFilter(array: any[], field: string | undefined | null, fieldTitle: string, operator: string = "$containsi") {
  if(field) {
    const tempArray: any[] = [];
    mountFilter(tempArray, field, fieldTitle, operator);
    mountFilter(tempArray, `${field}`.toUpperCase(), fieldTitle, operator);
    mountFilter(tempArray, `${field}`.toLowerCase(), fieldTitle, operator);

    array.push({
      $or: tempArray
    })
  }
}

function mapFilter(search: Search) {
  let filters: any = {};

  let or: any[] = [];
  if(search.buscaLivre) {
    mountCaseSensitiveFilter(or, search.buscaLivre, 'description');
    mountCaseSensitiveFilter(or, search.buscaLivre, 'title');
    mountCaseSensitiveFilter(or, search.buscaLivre, 'author');
    mountCaseSensitiveFilter(or, search.buscaLivre, 'index');
    
    filters.$or = or;
  }

  let and: any[] = []
  mountFilter(and, search.initialDate, 'date', '$gte');
  mountFilter(and, search.finalDate, 'date', '$lte');

  mountCaseSensitiveFilter(and, search.author, 'author');
  mountFilter(and, search.index, 'index');

  filters.$and = and;
  return filters
}

export function useBlogs(): Response {
  const initialData: Response = {
    results: [], 
    pagination: {
      page: -1,
      pageCount: -1,
      pageSize: -1,
      total: -1
    }
  }
  const [data, setData] = useState<Response>(initialData);
  
  async function fetchData() {
    let query: UrlParams = {
      populate: "*",
      pagination: {
        page: 1,
        pageSize: 10
      },
      sort: ['important:desc', 'date:desc', 'createdAt:desc', 'title:asc'],
    };

    setData(await makeRequest(query));
  }

  useEffect(() => {
    // if(data?.results?.length) return;
    fetchData();
  }, [data.pagination.page]);

  return data;
};


export async function getBlogs(search: Search | null = null,  page: number = 1): Promise<Response> {
  let query: UrlParams = {
    populate: "deep",
    pagination: {
      page: page,
      pageSize: 10
    },
    sort: ['important:desc', 'date:desc', 'createdAt:desc', 'title:asc'],
  };
  if(search) {
    query.filters = mapFilter(search);
  }
  return await makeRequest(query);
}


async function makeRequest(query: any): Promise<Response> {
  const response: apiResponse = await fetchAPI("/posts", query);
    return {
      results: response.data.map((item: any) => mapResponse(item)),
      pagination: response.meta.pagination
    };
}